module.exports = __webpack_public_path__ + "static/media/nn-Nonord-distraction-TALL.cd16bdb6.mp3";